module.exports = __webpack_public_path__ + "media/images/country_flags/ee-c8a156e6f87b70a410409d415fb8a408.png";